export default __webpack_public_path__ + "static/4-0d4bf28e8e4b85bd0bef05423828da1d.png";